import { SelectionMode } from '@fluentui/react';
import { IconButton } from 'office-ui-fabric-react';
import React, { Component, Fragment } from 'react';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataContratDeReservation } from '../../data/DataContratDeReservation';
import { Immocom } from '../../specifique/immocom';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { FicheCorrigerReservation } from '../Fiche/FicheCorrigerReservation';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class DetailsListContratsElectroniques extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListContratsElectroniquesWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

// KP - 2562 - 23/10/2023 : correction multiple commentée car mal optimisée et peut-être pas utilisée
class DetailsListContratsElectroniquesWithPerimetre extends Component {

    static defaultProps = {
        afficherContratsASigner: false,
        afficherContratsSignes: false,
        perimetre: {}
    };

    static defaultState = {
        afficherPanelCorrigerReservation: false,
        items: [],
        itemsSelectionnes: [],
        /* --- */
        pageIndex: 1,
        facteurNbreEnregistrement: 100,
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListContratsElectroniquesWithPerimetre.defaultState };
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = false;
        this._sortedColumn = "region";
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des contrats en cours..."
        });

        const { facteurNbreEnregistrement, pageIndex } = this.state;
        const tri = `${this._sortedColumn} ${this._isSortedDescending ? "DESC" : "ASC"}`;

        DataContratDeReservation._chargementContratsDeReservationsPourCorriger(this._filtres, tri, facteurNbreEnregistrement, pageIndex).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const newItems = objetData || [];

                let items = [];
                if (pageIndex === 1) items = newItems;
                else {
                    items = [...this.state.items];
                    items = items.concat(newItems);
                }

                const state = { items };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurAvecState(this, { items: [] }, retourVerif, responseFetch);
        });

    };

    _getColumns = () => {
        return [{
            key: "region",
            minWidth: 75,
            maxWidth: 150,
            name: "Région"
        }, {
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            key: "agence",
            minWidth: 75,
            maxWidth: 150,
            name: "Agence",
        }, {
            key: "nomCommercial",
            name: "Opération",
        }, {
            key: "nomClient",
            minWidth: 350,
            maxWidth: 450,
            name: "Clients",
        }, {
            key: "numero",
            minWidth: 100,
            maxWidth: 100,
            name: "N° lot",
        }, {
            isIconOnly: true,
            key: "signer",
            onRender: (item) => <IconButton
                disabled={item.signeEiffage}
                iconProps={{ iconName: "InsertSignatureLine" }}
                onClick={this._togglePanelCorrigerSignature(true, item)}
                title="Consulter & corriger"
            />
        }];
    };

    _getFiltres = () => {
        const { afficherContratsASigner, afficherContratsSignes } = this.props;
        let filtres = { afficherContratsASigner, afficherContratsSignes };
        return filtres;
    };

    // KP - 2562
    //_getItems = () => {
    //    return [{
    //        disabled: this.state.itemsSelectionnes.length === 0,
    //        key: "signature",
    //        name: "Corriger les réservations",
    //        iconProps: { iconName: "InsertSignatureLine" },
    //        onClick: this._signerContrats
    //    }];
    //};

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        this._sortedColumn = sortedColumn;
        this._isSortedDescending = isSortedDescending;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    // KP - 2562
    //_signerContrats = () => {

    //    const { itemsSelectionnes } = this.state;

    //    let promises = [];
    //    itemsSelectionnes.forEach((contrat) => {

    //        const { dateDeSignatureEiffageManuelle, dateSignatureEiffageElectronique, dateSignatureElectronique, idOperation, idReservation, nomDocument, rowGUID } = contrat;
    //        const objet = { dateDeSignatureEiffageManuelle, dateSignatureEiffageElectronique, dateSignatureElectronique, idOperation, idReservation, nomDocument, rowGUID };

    //        DataContratDeReservation._chargementSignatureElectroniqueInformation(objet).then(responseFetch => {
    //            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
    //            if (retourVerif === null) {

    //                let idContacts = [];
    //                if (Array.isArray(responseFetch.reponseAPIobjet.idContacts && responseFetch.reponseAPIobjet.idContacts.length !== 0))
    //                    idContacts = responseFetch.reponseAPIobjet.idContacts;

    //                const newObjet = { idContacts, idOperation, idReservation, rowGUID };
    //                const correctionSignatureElectroniqueParEI = DataContratDeReservation._corrigerSignatureElectroniqueParEI(newObjet);
    //                promises.push(correctionSignatureElectroniqueParEI);
    //            }
    //        });
    //    });

    //    Promise.all(promises).then(responsePromise => {
    //        const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responsePromise, this);
    //        if (retourVerif === null)
    //            Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
    //        else Immocom.onTraitementErreurPromise(this, retourVerif);
    //    });

    //};

    _togglePanelCorrigerSignature = (isOpen, item, callback) => () => {
        item = item || [];
        const itemsSelectionnes = Array.isArray(item) ? item : [item];
        this.setState(
            {
                afficherPanelCorrigerReservation: isOpen,
                itemsSelectionnes
            },
            typeof callback === "function" ? callback() : null
        );
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const { afficherPanelCorrigerReservation, items, itemsSelectionnes } = this.state; // KP - 2562

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <MessageBars
                errorMessage={this.state.errorMessage}
                infoMessage={this.state.messageMessageBarFiltres}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            <EUIDetailsList
                //canSelectItem={item => !item.signeEiffage} // KP - 2562
                columns={this._columns}
                getKey={item => `${item.idOperation};${item.idReservation}`}
                isSortedDescending={this._isSortedDescending}
                items={items}
                //menuItems={this._getItems()} // KP - 2562
                onColumnHeaderClick={this._onColumnHeaderClick}
                onSearch={this._onSearch}
                //onSelectionChanged={items => this.setState({ itemsSelectionnes: items })} // KP - 2562
                //selectionMode={SelectionMode.multiple} // KP - 2562
                selectionMode={SelectionMode.none} // KP - 2562
                sortedColumn={this._sortedColumn}
            />

            <FicheCorrigerReservation
                contrat={itemsSelectionnes.length > 0 ? itemsSelectionnes[0] : {}}
                isOpen={afficherPanelCorrigerReservation}
                onDismiss={this._togglePanelCorrigerSignature(false)}
                onSolve={this._togglePanelCorrigerSignature(false, null, this._chargementDonnees)}
            />

        </Fragment>;
    };

};